"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiArtifactRecordingRecordingStatus = exports.StreemApiArtifactRecordingRecordingSource = exports.StreemApiArtifactRecordingStatus = exports.StreemApiArtifactRecordingToJSON = exports.StreemApiArtifactRecordingFromJSONTyped = exports.StreemApiArtifactRecordingFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiArtifactRecordingFromJSON(json) {
    return StreemApiArtifactRecordingFromJSONTyped(json, false);
}
exports.StreemApiArtifactRecordingFromJSON = StreemApiArtifactRecordingFromJSON;
function StreemApiArtifactRecordingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bucket': !(0, runtime_1.exists)(json, 'bucket') ? undefined : json['bucket'],
        'filename': !(0, runtime_1.exists)(json, 'filename') ? undefined : json['filename'],
        'storageUrl': !(0, runtime_1.exists)(json, 'storage_url') ? undefined : json['storage_url'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'requestedAt': !(0, runtime_1.exists)(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'startedTransferringAt': !(0, runtime_1.exists)(json, 'started_transferring_at') ? undefined : (new Date(json['started_transferring_at'])),
        'erroredAt': !(0, runtime_1.exists)(json, 'errored_at') ? undefined : (new Date(json['errored_at'])),
        'fulfilledAt': !(0, runtime_1.exists)(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'recordingSource': !(0, runtime_1.exists)(json, 'recording_source') ? undefined : json['recording_source'],
        'previewStorageUrl': !(0, runtime_1.exists)(json, 'preview_storage_url') ? undefined : json['preview_storage_url'],
        'previewUrl': !(0, runtime_1.exists)(json, 'preview_url') ? undefined : json['preview_url'],
        'duration': !(0, runtime_1.exists)(json, 'duration') ? undefined : (0, _1.GoogleProtobufDurationFromJSON)(json['duration']),
        'recordingStatus': !(0, runtime_1.exists)(json, 'recording_status') ? undefined : json['recording_status'],
        'deletedAt': !(0, runtime_1.exists)(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
exports.StreemApiArtifactRecordingFromJSONTyped = StreemApiArtifactRecordingFromJSONTyped;
function StreemApiArtifactRecordingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bucket': value.bucket,
        'filename': value.filename,
        'storage_url': value.storageUrl,
        'status': value.status,
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'started_transferring_at': value.startedTransferringAt === undefined ? undefined : (value.startedTransferringAt.toISOString()),
        'errored_at': value.erroredAt === undefined ? undefined : (value.erroredAt.toISOString()),
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'url': value.url,
        'recording_source': value.recordingSource,
        'preview_storage_url': value.previewStorageUrl,
        'preview_url': value.previewUrl,
        'duration': (0, _1.GoogleProtobufDurationToJSON)(value.duration),
        'recording_status': value.recordingStatus,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
exports.StreemApiArtifactRecordingToJSON = StreemApiArtifactRecordingToJSON;
/**
* @export
* @enum {string}
*/
var StreemApiArtifactRecordingStatus;
(function (StreemApiArtifactRecordingStatus) {
    StreemApiArtifactRecordingStatus["REQUESTED"] = "STATUS_REQUESTED";
    StreemApiArtifactRecordingStatus["TRANSFERRING"] = "STATUS_TRANSFERRING";
    StreemApiArtifactRecordingStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactRecordingStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactRecordingStatus["INVALID"] = "STATUS_INVALID";
})(StreemApiArtifactRecordingStatus = exports.StreemApiArtifactRecordingStatus || (exports.StreemApiArtifactRecordingStatus = {}));
/**
* @export
* @enum {string}
*/
var StreemApiArtifactRecordingRecordingSource;
(function (StreemApiArtifactRecordingRecordingSource) {
    StreemApiArtifactRecordingRecordingSource["TWILIO"] = "SOURCE_TWILIO";
    StreemApiArtifactRecordingRecordingSource["MUXER"] = "SOURCE_MUXER";
    StreemApiArtifactRecordingRecordingSource["ONDEVICE"] = "SOURCE_ON_DEVICE";
    StreemApiArtifactRecordingRecordingSource["ARAAS"] = "SOURCE_ARAAS";
    StreemApiArtifactRecordingRecordingSource["CHIME"] = "SOURCE_CHIME";
    StreemApiArtifactRecordingRecordingSource["INVALID"] = "SOURCE_INVALID";
})(StreemApiArtifactRecordingRecordingSource = exports.StreemApiArtifactRecordingRecordingSource || (exports.StreemApiArtifactRecordingRecordingSource = {}));
/**
* @export
* @enum {string}
*/
var StreemApiArtifactRecordingRecordingStatus;
(function (StreemApiArtifactRecordingRecordingStatus) {
    StreemApiArtifactRecordingRecordingStatus["NONE"] = "RECORDING_STATUS_NONE";
    StreemApiArtifactRecordingRecordingStatus["PAUSED"] = "RECORDING_STATUS_PAUSED";
    StreemApiArtifactRecordingRecordingStatus["RESUMED"] = "RECORDING_STATUS_RESUMED";
    StreemApiArtifactRecordingRecordingStatus["TEMPORARYFAILURE"] = "RECORDING_STATUS_TEMPORARY_FAILURE";
    StreemApiArtifactRecordingRecordingStatus["INVALID"] = "RECORDING_STATUS_INVALID";
})(StreemApiArtifactRecordingRecordingStatus = exports.StreemApiArtifactRecordingRecordingStatus || (exports.StreemApiArtifactRecordingRecordingStatus = {}));
//# sourceMappingURL=StreemApiArtifactRecording.js.map